// Wait until the entire page is fully loaded
window.addEventListener("load", function () {
  console.log("test");
  // Function to dynamically append a script to the head
  function loadScript(src) {
    console.log("loaded", src);

    const script = document.createElement("script");
    script.src = src;
    script.async = true; // Ensure the script is loaded asynchronously
    document.head.appendChild(script);
  }

  // Function to dynamically append a stylesheet to the head
  function loadStylesheet(href) {
    console.log("loaded", href);

    const link = document.createElement("link");
    link.href = href;
    link.rel = "stylesheet";
    link.type = "text/css";
    document.head.appendChild(link);
  }

  // List of scripts to append after page load
  const scriptsToLoad = [
    "https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js",
    "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.js",
    "https://gsstatic.greenstory.ca/widgets/app/greenstoryinit.js",
    "https://ds0wlyksfn0sb.cloudfront.net/redirect.js",
    // Add more scripts as needed
  ];

  // List of stylesheets to append after page load
  const stylesheetsToLoad = [
    "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.css",
    "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css",
    "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css",
  ];

  // Append each script
  scriptsToLoad.forEach(loadScript);

  // Append each stylesheet
  stylesheetsToLoad.forEach(loadStylesheet);
});
